import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

const DIRS = [
    { x: 0,     y: -1    }, { x: 0.71,  y: -0.71 },
    { x: 1,     y: 0     }, { x: 0.71,  y: 0.71  },
    { x: 0,     y: 1     }, { x: -0.71, y: 0.71  },
    { x: -1,    y: 0     }, { x: -0.71, y: -0.71 },
];

const BURST_DURATION = 550;

export default function BurstBtn({ children, to, onClick, className = '', type = 'button', disabled, ...rest }) {
    const [burst, setBurst] = useState(false);
    const history = useHistory();

    const fire = useCallback((e) => {
        if (disabled || burst) return;
        e.preventDefault();
        setBurst(true);
        setTimeout(() => {
            setBurst(false);
            if (to) history.push(to);
            else if (onClick) onClick();
        }, BURST_DURATION);
    }, [burst, disabled, to, onClick, history]);

    return (
        <span className="burst-wrap">
            <button
                className={className}
                onClick={fire}
                type={type}
                disabled={disabled || burst}
                {...rest}
            >
                {children}
            </button>
            {burst && DIRS.map((d, i) => (
                <span
                    key={i}
                    className="wishes-petal"
                    style={{
                        '--tx': `${d.x * 55}px`,
                        '--ty': `${d.y * 55}px`,
                        animationDelay: `${i * 0.04}s`,
                        fontSize: '14px',
                    }}
                >🌸</span>
            ))}
        </span>
    );
}
